export default function listCarousel() {
    $('.list__images').slick({
        dots: true,
        infinite: true,
        speed: 300,
        slidesToShow: 2,
        slidesToScroll: 2,
        variableWidth: false,
        prevArrow:"<img class='a-left control-c prev slick-prev' src='/images/blocks/gallery/prev-arrow.svg' alt='Previous Arrow' >",
        nextArrow:"<img class='a-right control-c next slick-next' src='/images/blocks/gallery/arrow.svg' alt='Next Arrow' >",
        responsive: [
          {
            breakpoint: 576,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]
      });
}

document.addEventListener('readystatechange', () => {

        listCarousel();

});
